import i18n from 'i18next'
import resourcesToBackend from 'i18next-resources-to-backend'
import { initReactI18next } from 'react-i18next'

export const supportedLanguages = ['en', 'de']

i18n
  .use(initReactI18next)
  .use(resourcesToBackend((language, namespace, callback) => {
    import(`./locales/${language}/${namespace}.json`)
      .then(translation => {
        callback(null, translation)
      })
      .catch(error => {
        console.error('error loading translation', language, namespace, error)
        callback(error, null)
      })
  }))
  .on('failedLoading', (lng, ns, msg) => { console.error('failedLoading', lng, ns, msg) })
  .init({
    lng: 'de',
    fallbackLng: 'en',
    supportedLngs: supportedLanguages,
    defaultNS: 'common',
    ns: ['landingpage', 'sessionview', 'objecteditor', 'userlist', 'chatview', 'settings', 'upload', 'common'],
  })

export default i18n
